import { POWER_STRIKE } from '../cards/attack/power-strike';
import { ROULETTE_STRIKE } from '../cards/recursive/roulette-strike';
import { WILD_LIGHTNING } from '../cards/recursive/wild-lightning';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Rare tier: 3×3, 3 dice, greedy damage-max AI.
 * Swingy gambler — fresh-roll burst that can spike for a chunk or fizzle (and
 * occasionally singe itself). The greedy AI funds the recursives because they
 * resolve to damage; the *feel* is luck-band, not brute force. */
export const EMBERCALLER: EnemyTemplate = {
  id: 'embercaller',
  name: 'Embercaller',
  glyph: '☄', // comet — falling fire
  tier: 'rare',
  hp: 24,
  loadout: [
    { card: WILD_LIGHTNING, origin: { row: 0, col: 0 }, rotated: false },
    { card: ROULETTE_STRIKE, origin: { row: 0, col: 1 }, rotated: false },
    { card: POWER_STRIKE, origin: { row: 2, col: 0 }, rotated: false },
  ],
  drops: { gold: 8 },
};
